function mainSlider() {
    var swiper = new Swiper('.main .swiper-container', {
        slidesPerView: 1,
        effect: 'fade',
        loop: true,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.main .swiper-button-next',
            prevEl: '.main .swiper-button-prev',
        },
        pagination: {
            el: '.main .swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
    })
}

let collectionSlidersArray = []

function collectionSlider() {
    $(".collection").each(function(index, el) {
        $(el).attr("data-slider-id", `${index}`)
        collectionSlidersArray[index] = new Swiper(`.collection[data-slider-id="${index}"] .swiper-container`, {
            slidesPerView: "auto",
            spaceBetween: 0,
            navigation: {
                nextEl: `.collection[data-slider-id="${index}"] .swiper-button-next`,
                prevEl: `.collection[data-slider-id="${index}"] .swiper-button-prev`,
            },
        })
    })
}


let SlidersArray = []

function sliders() {
    $(".slider-wrap").each(function(index, el) {
        $(el).attr("data-slider-id", `${index}`)
        SlidersArray[index] = new Swiper(`.slider-wrap[data-slider-id="${index}"] .swiper-container`, {
            slidesPerView: "auto",
            spaceBetween: 0,
        })
    })
}

function doctorsSlider() {
    var swiper = new Swiper('.doctors__slider .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        // centeredSlides: true,
        loop: true,
        loopAdditionalSlides: 10,
        autoplay: {
            delay: 4000
        }
    })
}

function caseSlider() {
    var swiper = new Swiper('.case-page .swiper-container', {
        slidesPerView: 1,
        effect: 'fade',
        loop: true,
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: '.case-page .swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
    })
}

function recoverSlider() {
    var swiper = new Swiper('.recover .swiper-container', {
        slidesPerView: "auto",
        spaceBetween: 0,
        navigation: {
            nextEl: `.recover .swiper-button-next`,
            prevEl: `.recover .swiper-button-prev`,
        },
    })
}

function valuesSlider() {
    var swiper = new Swiper('.value2 .swiper-container', {
        slidesPerView: "auto",
        spaceBetween: 0,
        grid: {
            fill: 'row',
            rows: 2,
        },
    })
}


let imagesSlidersArray = []

function imgSlider() {
    $(".img-modal").each(function(index, el) {
        $(el).attr("data-slider-id", `${index}`)
        imagesSlidersArray[index] = new Swiper(`.img-modal[data-slider-id="${index}"] .swiper-container`, {
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
                el: `.img-modal[data-slider-id="${index}"] .swiper-pagination`,
                type: 'bullets',
                clickable: true,
            },
            navigation: {
                nextEl: `.img-modal[data-slider-id="${index}"] ._next-slide`,
            },
        })

        // $(`.img-modal[data-slider-id="${index}"] ._next-slide`).click(function () {
        //     imagesSlidersArray[index].slide
        // })

    })
}

mainSlider()
collectionSlider()
sliders()
doctorsSlider()
caseSlider()
recoverSlider()
valuesSlider()
imgSlider()
